import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  dialogModal: {
    '& .MuiPaper-root': {
      maxWidth: '480px',
    },
    '& .MuiTypography-subtitle1': {
      fontSize: '1.3rem',
      fontWeight: 'bold',
    }
  },
  inputContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },
  inputLabel: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    width: '150px',
    textAlign: 'center'
  },
  selectionText: {
    width: '180px',
    height: '50px',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '1rem',
    '& input': {
      fontSize: '1rem',
      fontWeight: 'bold',
    },
    '& .MuiFormHelperText-root': {
      marginLeft: 0,
      textAlign: 'left',
    },
  }
}));
export default styles;
